import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { UploadResponse } from '@dto/uploadResponse';
import { AuthenticationService } from '@services/authentication/authentication.service';
import { EventService } from '@services/event/event.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FilesService {

  userConfig;
  customerConfig;
  operatorConfig;

  constructor(
    private http: HttpClient,
    @Inject('BASE_URL') private baseUrl: string,
    private eventService: EventService,
    private authenticationService: AuthenticationService
  ) {
    this.authenticationService.authChanged$.subscribe(result => {
      if (result) {
        this.initializeConfigurations();
      }
    })
  }

  async initializeConfigurations() {
    this.userConfig = await this.getJsonAsync("config/roles/config.user.json", true);
    this.customerConfig = await this.getJsonAsync("config/roles/config.customer.json", true);
    this.operatorConfig = await this.getJsonAsync("config/roles/config.operator.json", true);
    this.eventService.sendFilesLoaded();
  }

  public async getNotifications() {
    return await this.getJsonAsync("config/roles/notifications.json", true);
  }

  upload(formData: FormData): Observable<UploadResponse> {
    return this.http.post<UploadResponse>(this.baseUrl + 'api/files/upload', formData);
  }

  async getAsync(fileName: string, isGeneralStorage?: boolean): Promise<any> {
    let params = new HttpParams()
      .set('isJson', 'false')
      .set('fileName', fileName)
      
    if (isGeneralStorage) {
      params = params.set('isGeneralStorage', isGeneralStorage.toString());
    }

    return await this.http.get<any>(this.baseUrl + 'api/files', { params: params}).toPromise();
  }

  async getJsonAsync(fileName: string, isGeneralStorage?: boolean): Promise<any> {
    let params = new HttpParams()
      .set('isJson', 'true')
      .set('fileName', fileName)

    if (isGeneralStorage) {
      params = params.set('isGeneralStorage', isGeneralStorage.toString());
    }

    return await this.http.get<any>(this.baseUrl + 'api/files', { params: params }).toPromise();
  }

  async uploadAsync(formData: FormData, isPublic: boolean = false): Promise<UploadResponse[]> {
    return await this.http.post<UploadResponse[]>(`${this.baseUrl}api/files/upload${isPublic ? '/public' : '/'}`, formData).toPromise();
  }

  download(fileName: string, downloadFileName?: string, isGeneralStorage?: boolean) {
    let params = new HttpParams()
      .set('fileName', fileName)

    if (isGeneralStorage) {
      params = params.set('isGeneralStorage', isGeneralStorage.toString());
    }

    this.http.get(this.baseUrl + 'api/files/download', { params: params, responseType: 'blob' }).subscribe(result => {
      var url = window.URL.createObjectURL(result);
      var anchor = document.createElement("a");
      anchor.download = downloadFileName ? downloadFileName : fileName;
      anchor.href = url;
      anchor.click();
    });
  }

  fileExists(fileName: string, isGeneralStorage?: boolean): Observable<boolean> {
    let params = new HttpParams()
      .set('fileName', fileName)

    if (isGeneralStorage) {
      params = params.set('isGeneralStorage', isGeneralStorage.toString());
    }

    return this.http.get<boolean>(this.baseUrl + 'api/files/exists', { params: params });
  }

  whitelabelExists(whitelabel: string): Observable<boolean> {
    let params = new HttpParams()
      .set('whitelabel', whitelabel)

    return this.http.get<boolean>(this.baseUrl + 'api/files/whitelabel', { params: params });
  }

  getPicture(fileName: string, isGeneralStorage?: boolean, fileType?: string) {
    let params = new HttpParams()
      .set('fileName', fileName)

    if (isGeneralStorage) {
      params = params.set('isGeneralStorage', isGeneralStorage.toString());
    }

    if (fileType) {
      params = params.set('fileType', fileType);
    }

    return this.http.get(this.baseUrl + 'api/files/image', { params: params, responseType: 'blob' });
  }

  getPublicImage(fileName: string, fileType?: string) {
    let params = new HttpParams()
      .set('fileName', fileName)

    if (fileType) {
      params = params.set('fileType', fileType);
    }

    return this.http.get(this.baseUrl + 'api/files/public/image', { params: params, responseType: 'blob' });
  }

  getSVG(fileName: string) {
    let params = new HttpParams()
    return this.http.get(`${this.baseUrl}assets/${fileName}.svg`, { params: params, responseType: 'text' });
  }

  getFileList(directory: string, isGeneralStorage?: boolean) {
    let params = new HttpParams().set('directory', directory)
    if (isGeneralStorage) {
      params = params.set('isGeneralStorage', isGeneralStorage.toString());
    }
    return this.http.get(this.baseUrl + 'api/files/ListDirectory', { params: params, responseType: 'text' });
  }

 

}
